import React, { useState, useEffect } from 'react';
import { useLocation, useOutletContext } from 'react-router-dom';
import QuickAccessMenu from '../../components/QuickAccessMenu/QuickAccessMenu';
import Contact from '../../components/Contact/Contact';

export default function Users() {
  const { user } = useOutletContext(); 
  const location = useLocation();

  // "dashboard" is the new default view, replacing "folders"
  const [currentView, setCurrentView] = useState("dashboard"); 

  useEffect(() => {
    if (location.state?.targetView) {
      // If the layout passes "folders", map it to "dashboard"
      const target = location.state.targetView === "folders" ? "dashboard" : location.state.targetView;
      setCurrentView(target);
    }
  }, [location.state]);

  return (
    <div id="dynamicContainer">
      {currentView === "dashboard" && (
        <QuickAccessMenu />
      )}

      {currentView === "contact" && (
        <Contact />
      )}

      {currentView === "profile" && (
        <div className="profile-view" style={{ padding: '2rem', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginTop: '20px' }}>
          <h2 style={{ marginTop: 0, color: '#0f172a' }}>My Profile</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '20px' }}>
            <img 
              src={user?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.displayName || "Student")}&background=f1f5f9&color=0f172a`} 
              alt="Profile" 
              style={{ width: '60px', height: '60px', borderRadius: '50%' }}
            />
            <div>
              <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', fontSize: '1.1rem' }}>{user?.displayName || "Student"}</p>
              <p style={{ margin: 0, color: '#64748b' }}>{user?.email}</p>
            </div>
          </div>
        </div>
      )}

      {currentView === "settings" && (
        <div className="settings-view" style={{ padding: '2rem', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginTop: '20px' }}>
          <h2 style={{ marginTop: 0, color: '#0f172a' }}>Account Settings</h2>
          <p style={{ color: '#64748b' }}>Preferences and account configuration will go here.</p>
        </div>
      )}
    </div>
  );
}